import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
import api from '../../utils/api.service';
import { ENDPOINTS } from '../../utils/api-config';
import { toast } from 'react-toastify';
import './Promotions.css';

const PromotionsList = () => {
  const [promotions, setPromotions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0
  });

  const fetchPromotions = async () => {
    setLoading(true);
    try {
      const params = {
        page: pagination.page,
        limit: pagination.limit
      };
      const response = await api.get(ENDPOINTS.PROMOTIONS.base, { params });
      const promosData = response.data || [];
      setPromotions(promosData.data || []);
      setPagination(prev => ({ ...prev, total: promosData.meta?.total || 0 }));
    } catch (error) {
      console.error('Failed to fetch promotions:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this promotion?')) {
      try {
        await api.delete(`${ENDPOINTS.PROMOTIONS.base}/${id}`);
        toast.success('Promotion deleted successfully');
        fetchPromotions();
      } catch (error) {
        console.error('Failed to delete promotion:', error);
        toast.error('Failed to delete promotion');
      }
    }
  };

  useEffect(() => {
    fetchPromotions();
  }, [pagination.page]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loader"></div>
        <p>Fetching promotions...</p>
      </div>
    );
  }

  return (
    <div className="promotions-page">
      <div className="page-header">
        <div>
          <h1>Promotions & Coupons</h1>
          <p className="page-subtitle">Manage promotional campaigns and discount codes</p>
        </div>
        <div className="page-actions">
          <Link to="/promotions/create" className="btn btn-primary">
            <FaPlus /> Create Promotion
          </Link>
        </div>
      </div>

      {/* Promotions Table (Changed from Grid for consistency) */}
      <div className="content-card">
        <div className="card-header">
          <h3>All Promotions ({promotions.length})</h3>
        </div>

        <div className="table-responsive">
          <table className="table table-hover align-middle custom-table">
            <thead>
              <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Discount</th>
                <th>Status</th>
                <th>Usage</th>
                <th>Validity</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {promotions.map((promo) => (
                <tr key={promo.id}>
                  <td>
                    <div className="promo-code-badge">{promo.code}</div>
                  </td>
                  <td>{promo.name}</td>
                  <td>
                    {promo.discountType === 'PERCENTAGE' 
                      ? `${promo.discountValue}%` 
                      : `$${promo.discountValue}`
                    }
                  </td>
                  <td>
                    {promo.status === 'active' ? (
                      <span className="badge badge-success">Active</span>
                    ) : (
                      <span className="badge badge-danger">{promo.status}</span>
                    )}
                  </td>
                  <td>{promo.currentUses || 0} / {promo.maxUsesTotal || '∞'}</td>
                  <td>
                    {new Date(promo.validFrom).toLocaleDateString()} - {new Date(promo.validUntil).toLocaleDateString()}
                  </td>
                  <td>
                    <div className="action-buttons">
                      <Link to={`/promotions/${promo.id}/edit`} className="btn-icon" title="Edit">
                        <FaEdit />
                      </Link>
                      <button className="btn-icon delete" title="Delete" onClick={() => handleDelete(promo.id)}>
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PromotionsList;